import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { AuthProvider } from "@/auth/AuthContext";
import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import Home from "@/pages/Home";
import Check from "@/pages/Check";
import Pricing from "@/pages/Pricing";
import Faq from "@/pages/Faq";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import History from "@/pages/History";
import Account from "@/pages/Account";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import AdminInbox from "@/pages/AdminInbox";
import ExpertDashboard from "@/pages/ExpertDashboard";
import LegalPage from "@/pages/LegalPage";
import SharedResult from "@/pages/SharedResult";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <div className="flex min-h-screen flex-col bg-[#F8FAFC]">
            <Navbar />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/check" element={<Check />} />
                <Route path="/s/:id" element={<SharedResult />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/faq" element={<Faq />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/login" element={<Login />} />
                <Route path="/history" element={<History />} />
                <Route path="/account" element={<Account />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
                <Route path="/admin" element={<AdminInbox />} />
                <Route path="/expert" element={<ExpertDashboard />} />
                <Route path="/privacy" element={<LegalPage pageKey="privacy" />} />
                <Route path="/terms" element={<LegalPage pageKey="terms" />} />
                <Route path="/cookies" element={<LegalPage pageKey="cookies" />} />
                <Route path="/security" element={<LegalPage pageKey="security" />} />
                <Route path="*" element={<Home />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
